import actionTypes from '../constants/action-types';

const setPages = (pages) => ({
  type: actionTypes.SET_PAGES,
  payload: {
    pages,
  },
});

export default setPages;
